// Platform detection — returns true when running inside Capacitor on iOS.
// Used to gate IAP-only code paths and hide non-Apple payment surfaces
// (Apple rejects apps that link out to web payment).

import { Capacitor } from "@capacitor/core";

export const isNative = () => Capacitor.isNativePlatform();
export const isIOS = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios";
export const isAndroid = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";
export const isWeb = () => !Capacitor.isNativePlatform();
